import React from "react";

import { hasAppsPermission } from "app/components/sidebar3/dynamic-config/configs/sidebar31/list-items/salesListItems";
import { WEBSITE_ANALYSIS_PERFORMANCE } from "app/pages/sales-intelligence/constants/routes";
import { openHooksModalV5 } from "app/services/ModalService";
import { swSettings } from "app/common/services/swSettings";
import { AppTooltip } from "pro-features/components/tooltips/src/AppTooltip/AppTooltip";
import { AppStoreID, AppStoreName } from "app/pages/app-intelligence/constants";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import {
    AppIconImage,
    AppIconLink,
    CarouselContainer,
    CarouselContainerInner,
    LeftButton,
    RightButton,
} from "./styles";
import { usePosition } from "./usePosition";

interface IAppItemWithTooltip {
    apps: any;
    store: string;
    onClick?: any;
    onClickTrackTitle?: string;
    aClassName?: string;
    imgClassName?: string;
    limitApps?: number;
    hideMonthlyDownloads?: boolean;
}

const WebsitePerformanceAppItem: React.FC<IAppItemWithTooltip> = ({
    apps,
    onClick,
    store,
    limitApps = 5,
    onClickTrackTitle,
    hideMonthlyDownloads,
}) => {
    const ref = React.useRef(undefined);
    const { hasItemsOnLeft, hasItemsOnRight, scrollRight, scrollLeft } = usePosition(ref, limitApps);

    const isSIWebsiteAnalysisPage = proNavigator.isCurrentStateName(WEBSITE_ANALYSIS_PERFORMANCE);
    const isSIAppsRestrictedUser = isSIWebsiteAnalysisPage && !hasAppsPermission();

    const handleClick = (title, onClickTrackTitle) => () => {
        if (isSIAppsRestrictedUser) {
            openHooksModalV5("SalesSolutionApps");
        }
        if (typeof onClick === "function") {
            onClick?.(title, onClickTrackTitle);
        }
    };

    const items = apps.slice(0, limitApps).map((item, index) => {
        const AppId = item.appId || item.AppId;
        const appsAppleURL = `${swSettings.swsites.apps + "/app-analysis/overview/apple/"}`;
        const appsGoogleURL = `${swSettings.swsites.apps + "/app-analysis/overview/google/"}`;
        const redirectURL =
            item.store.toString() === AppStoreID.GOOGLE || store === AppStoreName.GOOGLE
                ? appsGoogleURL + item.id
                : appsAppleURL + item.id;

        return (
            <AppTooltip
                key={index}
                appId={AppId ? AppId.substring(2, AppId.length) : AppId}
                store={store}
                placement={"bottom"}
                hideMonthlyDownloads={hideMonthlyDownloads}
            >
                <AppIconLink
                    href={isSIAppsRestrictedUser ? null : redirectURL}
                    onClick={handleClick(item.title, onClickTrackTitle)}
                >
                    <AppIconImage
                        src={item.icon || item.Icon}
                        alt={item.title || item.Title}
                    />
                </AppIconLink>
            </AppTooltip>
        );
    });
    return (
        <CarouselContainer
            role="region"
            aria-label="Related apps"
        >
            {hasItemsOnLeft || hasItemsOnRight ? (
                <LeftButton
                    iconSize="md"
                    iconName="chev-left-n"
                    onClick={scrollLeft}
                    isDisabled={!hasItemsOnLeft}
                    type="flat"
                    width="32px"
                    height="32px"
                />
            ) : null}
            <CarouselContainerInner ref={ref}>{items}</CarouselContainerInner>
            {hasItemsOnLeft || hasItemsOnRight ? (
                <RightButton
                    iconSize="md"
                    iconName="chev-right-n"
                    onClick={scrollRight}
                    isDisabled={!hasItemsOnRight}
                    type="flat"
                    width="32px"
                    height="32px"
                />
            ) : null}
        </CarouselContainer>
    );
};

export default WebsitePerformanceAppItem;
